import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ChevronDown, ChevronUp } from "lucide-react";

const ServiceArea = [
  {
    label: "Taksim Halı Yıkama",
    path: "/beyoglu/taksim-hali-yikama",
    description:
      "Taksim bölgesine özel halı yıkama hizmetimizde halılarınız özenle yıkanır, hızlı şekilde adresinize teslim edilir."
  },
  {
    label: "Cihangir Halı Yıkama",
    path: "/beyoglu/cihangir-hali-yikama",
    description:
      "Cihangir Mahallesi’nde halılarınızı el değmeden yıkıyor, steril ambalajla aynı gün teslim ediyoruz."
  },
  {
    label: "Kasımpaşa Halı Yıkama",
    path: "/beyoglu/kasimpasa-hali-yikama",
    description:
      "Kasımpaşa semtinde uygun fiyatlı ve hijyen garantili halı yıkama hizmeti sunuyoruz."
  }
];

const BeyogluSidebar = () => {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(true);

  return (
    <div className="mt-2 text-[#003132]">
      <h2 className="text-lg font-semibold mb-2 uppercase tracking-wide text-center">BEYOĞLU SERVİS ALANLARI</h2>

      <div className="bg-[#f1f5f9] p-4 rounded-xl shadow-sm border border-gray-200">
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="w-full flex justify-between items-center px-3 py-2 text-red-800 font-bold hover:bg-red-100 rounded-md"
        >
          Hizmet Bölgeleri {isOpen ? <ChevronUp size={18} /> : <ChevronDown size={18} />}
        </button>

        {isOpen && (
          <div className="mt-2 space-y-3">
            {ServiceArea.map((area, index) => (
              <div key={index}>
                <Link
                  to={area.path}
                  className={`block text-sm font-semibold px-3 py-1 rounded-lg transition-all duration-200 ${
                    location.pathname === area.path
                      ? "bg-red-600 text-white"
                      : "text-red-900 hover:bg-green-100 hover:text-red-800"
                  }`}
                >
                  {area.label}
                </Link>
                <p className="text-xs text-gray-600 mt-1 pl-1">{area.description}</p>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default BeyogluSidebar;
